var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.678 14.929A8.127 8.127 0 0 0 9.812 2.006 8.124 8.124 0 0 0 3.96 15.419a8.124 8.124 0 0 0 10.972 1.258h-.001c.037.05.077.097.122.143l4.813 4.814a1.25 1.25 0 1 0 1.768-1.768l-4.812-4.813a1.245 1.245 0 0 0-.144-.124Zm.323-4.806A6.878 6.878 0 0 1 10.126 17a6.873 6.873 0 0 1-6.875-6.875 6.876 6.876 0 0 1 11.736-4.862 6.876 6.876 0 0 1 2.014 4.862Z"
  })));
};
export default SvgSearch;